module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Light.65017fbe.woff";